// extracted by mini-css-extract-plugin
module.exports = {"openLink":"shared-module__openLink--LKv7I"};